var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-viewport-wrapper relative h-0 overflow-hidden bg-auto",staticStyle:{"padding-top":"100%"}},[_c('div',{staticClass:"app-viewport-window absolute top-0 left-0 w-full h-full max-h-main p-4"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }